module.exports = __webpack_public_path__ + "img/after920.9bc0fa00.jpg";